import { master, dashboard, content, mentors, subscriptions, commentSection, referralSection, readMore, parameters, invoiceListSection, expiringSubscribersSection, supportReportsSection, churnCohortSection, churnExitSurveySection, churnHealthDistributionSection, churnWorklistSection, churnScorecardSection, churnScorecardTargetsSection, churnWeeklyIndicatorsSection, churnDigestSection, churnRetentionLogSection, churnMessageTemplatesSection, churnOnboardingStatusSection, masterData } from "./modules/index";
import SupportReply from "./Components/SupportReply";

export default [
  {
    name: "div1",
    label: "Dashboard",
    //description: "Summaries",
    divider: true,
    icon: "i-Dashboard",
    access: ["superadmin", "provinsi", "kabkota", "dinas", "kecamatan", "opd","pemda","operator"],
  },
  ...dashboard,
  ...content,
  ...mentors,
  ...subscriptions,
  ...commentSection,
  ...referralSection,
  ...invoiceListSection,
  ...readMore,
  ...parameters,
  ...masterData,
  {
    name: "divReport",
    label: "Report",
    divider: true,
    icon: "i-Bar-Chart",
    access: ["superadmin"],
  },
  ...expiringSubscribersSection,
  ...churnCohortSection,
  ...churnExitSurveySection,
  ...churnHealthDistributionSection,
  ...churnWorklistSection,
  ...churnScorecardSection,
  ...churnScorecardTargetsSection,
  ...churnWeeklyIndicatorsSection,
  ...churnDigestSection,
  ...churnRetentionLogSection,
  ...churnMessageTemplatesSection,
  ...churnOnboardingStatusSection,
  ...supportReportsSection,
  {
    // Halaman balas laporan (tidak tampil di menu, diakses via tombol Balas).
    name: "Balas Laporan",
    slug: "supportReply",
    visible: false,
    crud: false,
    component: SupportReply,
    access: ["superadmin"],
  },
  {
    name: "div4",
    label: "Master Data",
  //  description: "lorem ipsum dolor sit amet",
    divider: true,
    icon: "i-Big-Data",
    access: ["superadmin"],
  },
 // account,
 ...master,
];
